import Hero from "../hero.png";

function Minter() {
  return (
    <div>
      <img
        style={{
          marginTop: "25px",
          marginBottom: "5px",
          alignSelf: "center",
          borderRadius: "10px",
          boxShadow:
            "rgb(0 0 0 / 50%) 0px 0px 0.25rem, rgb(255 0 0 / 50%) -0.125rem -0.125rem 1rem, rgb(240 255 0 / 50%) 0.125rem 0.125rem 1rem",
          // boxShadow: "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
        }}
        alt={"banner"}
        src={Hero}
      />
    </div>
  );
}

export default Minter;
